import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2fd7a3c0&"
import script from "@/controllers/ap/student/quiz/Index?v=3.0?vue&type=script&lang=ts&"
export * from "@/controllers/ap/student/quiz/Index?v=3.0?vue&type=script&lang=ts&"
import style0 from "@/assets/css/main.css?v=2.2?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports